<template>
    <div class="mvt-estprice grid xs-grid-cols-1" :class="{open: isOpen, less: !hasMore}">
        <div class="inline bg-default corner grid xs-grid-cols-1 outline">
            <div class="mvt-estprice-avm" v-if="showAVM && getAvmPrice">
                <h2 class="flex">
                    <span class="text-bold f6">Automated Valuation Model (AVM)</span>
                    <button type="button" @click="openDisclaimer2" ><i class="icon-Info-Circle"></i></button>
                </h2>
                <div>
                    <div class="text-bold f4 value">
                        {{ getAvmPrice }} <button v-if="isMymovotoUI" type="button" @click="openDisclaimer2"><i class="icon-Info-Circle"></i></button>

                    </div>
                    <div class="small f7">
                        AVM Range: <span>{{ getAvmRangText }}</span>
                    </div>
                </div>
            </div>
            <div class="mvt-estprice-mie" v-if="showPriceEst && estPrice">
                <h2 class="flex">
                    <span class="text-bold f6">Interactive Estimate (see comps below)</span>
                    <button type="button" @click="openDisclaimer"><i class="icon-Info-Circle"></i></button>
                </h2>
                <div>
                    <template v-if="isCompareLandWithHomes">
                        <div>
                            <b class="text-bold f4 value">{{ $filters.formatPrice(estPrice) }}</b>
                            <button v-if="isMymovotoUI" type="button" @click="openDisclaimer"><i class="icon-Info-Circle"></i></button>
                        </div>
                    </template>
                    <template v-else>
                        <div>
                            <div>
                                <b v-if="estPrice" class="text-bold f4 value">{{ $filters.formatPrice(estPrice) }}</b>
                                <b v-else-if="estAreaPrice" class="text-bold f4">{{ $filters.formatPricePerArea(estAreaPrice, dpp.isLand) }}{{ dpp.isLand ? '/Acre' : '/Sqft' }}</b>
                                <button v-if="isMymovotoUI" type="button" @click="openDisclaimer"><i class="icon-Info-Circle"></i></button>
                            </div>
                            <div v-if="!dpp.hideAvmAndRange && rangeText" class="f7">Estimate Range: {{ rangeText }}</div>
                        </div>
                    </template>
                    <div class="flex middle">
                        <div v-if="priceChanged">
                            <span class="text-gray f7">Last 30 days&nbsp;</span>
                            <span class="tag small" :class="isIncrease ? 'safe' : 'danger' ">{{ isIncrease ? '+' : '-' }}{{ $filters.formatFriendlyPrice(priceChanged) }}</span>
                        </div>
                        <div v-if="!dpp.hideAvmAndRange && forecastPriceChange">
                            <span class="f7 text-gray">1-year forecast&nbsp;</span>
                            <span class="tag small" :class="forecastPriceIncrease ? 'safe' : 'danger' "
                                >{{ forecastPriceIncrease ? '+' : '-' }}{{ $filters.formatFriendlyPrice(forecastPriceChange) }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <mvtEstPriceChart :isMarket5YLoaded="isMarket5YLoaded" :dpp="dpp" v-if="glb.enableThirdPart"></mvtEstPriceChart>

            <ul class="tab tab-bookmark" v-if="dpp.isLand">
                <li>
                    <a class="f4" :class="{'active':!isCompareLandWithHomes}" @click="estPriceByHome(false)">{{ molang('dpp.propertyEstimate.land') }}</a>
                </li>
                <li>
                    <a class="f4" :class="{'active':isCompareLandWithHomes}" @click="estPriceByHome(true)"> {{ molang('dpp.propertyEstimate.home') }}</a>
                </li>
            </ul>
            <div class="table-scroll list-table" style="border: none;">
                <table class="table" :class="{ 'hideDaysOnMarket': dpp.hideDaysOnMarket }" ref="homeValueComp">
                    <thead>
                        <tr>
                            <th></th>
                            <th colspan="2">
                                <mvtDropdownList size="small" :items="sourceTypes" v-model="comparableType" />
                            </th>
                            <th v-show="!compareWithLand">{{ molang('dpp.propertyEstimate.bed') }}</th>
                            <th v-show="!compareWithLand">{{ molang('dpp.propertyEstimate.bath') }}</th>
                            <th v-show="!compareWithLand">{{ molang('dpp.propertyEstimate.houseSize') }}</th>
                            <th v-if="compareWithLand">$/Acre</th>
                            <th v-else>$/Sqft</th>
                            <th v-show="!compareWithLand">{{ molang('dpp.propertyEstimate.yearBuilt') }}</th>
                            <th v-if="dpp.isCondo">
                                {{ molang('dpp.propertyEstimate.hoaFee') }}
                            </th>
                            <th v-else>{{ molang('dpp.propertyEstimate.lotSize') }}</th>
                            <th class="col-status">{{ comparableType === 'sold' ? 'Sold' : molang('dpp.propertyEstimate.status') }}</th>
                            <th>{{ molang('dpp.propertyEstimate.distance') }}</th>
                            <th>{{ molang('dpp.propertyEstimate.address') }}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <mvtEstPriceItem :item="dpp" :isCurrent="true" :compareWithLand="compareWithLand"></mvtEstPriceItem>
                        <template v-for="(prop, index) in comparableHomeSource">
                            <template v-if="comparableHomeSource && comparableHomeSource.length">
                                <mvtEstPriceItem :item="prop" :compareWithLand="compareWithLand" @remove="removeItem" :index="index" />
                            </template>
                        </template>
                    </tbody>
                </table>
            </div>
            <a class="show-hide-toggle" :class="{'shown': isOpen}" @click="toogleOpen()" role="button">{{ isOpen ? 'See fewer homes' : 'See more homes' }} <i></i></a>
            <div class="f8">
                {{ molang('dpp.propertyEstimate.estNote', { unit: dpp.isLand ? 'Acre' : 'Sqft' }) }}
                <a v-if="dpp.isPrOnly" class="link" @click.stop="favoriteAction">
                    <i v-if="isFavorite" class="icon-heart text-front"></i>
                    <span v-if="!isFavorite">{{ molang('dpp.getHomeUpdates') }}</span>
                    <span v-else>{{ molang('dpp.homeSaveProfile') }}</span>
                </a>
            </div>
        </div>



    </div>
</template>
<script src="./mvt-estprice.js"></script>
<style lang="scss">
    @use "./mvt-estprice.scss" as *;
</style>
